const BookedCalendar = () => {
  return (
    <svg
      width='80'
      height='80'
      viewBox='0 0 80 80'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M18.9999 19.6C17.6744 19.6 16.5999 20.6745 16.5999 22V64C16.5999 65.3255 17.6744 66.4 18.9999 66.4H60.9999C62.3254 66.4 63.3999 65.3255 63.3999 64V22C63.3999 20.6745 62.3254 19.6 60.9999 19.6H18.9999ZM11.6499 22C11.6499 16.6981 13.698 14.65 18.9999 14.65H60.9999C66.3018 14.65 68.3499 16.6981 68.3499 22V64C68.3499 69.302 66.3018 71.35 60.9999 71.35H18.9999C13.698 71.35 11.6499 69.302 11.6499 64V22Z'
        fill='#A95A23'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M52.375 8.5C54.239 8.5 55.75 9.82216 55.75 11.4531V21.2969C55.75 22.9278 54.239 24.25 52.375 24.25C50.511 24.25 49 22.9278 49 21.2969V11.4531C49 9.82216 50.511 8.5 52.375 8.5Z'
        fill='#A95A23'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M27.625 8.5C29.489 8.5 31 9.82216 31 11.4531V21.2969C31 22.9278 29.489 24.25 27.625 24.25C25.761 24.25 24.25 22.9278 24.25 21.2969V11.4531C24.25 9.82216 25.761 8.5 27.625 8.5Z'
        fill='#A95A23'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M13 33.25C13 32.0074 14.4222 31 16.1765 31H63.8235C65.5778 31 67 32.0074 67 33.25C67 34.4926 65.5778 35.5 63.8235 35.5H16.1765C14.4222 35.5 13 34.4926 13 33.25Z'
        fill='#A95A23'
      />
    </svg>
  );
};

export default BookedCalendar;
